import { h, render, Component } from 'preact';
import { classNames } from '../utils/utils';
import TxrExpandItem from './txr-expand-item';

class TxrPricingFaqItems extends Component {
    state = {
        isHighVolume: false,
        plans: []
    }
    render() {
        return (
            <div class="pricingpage-faq__items">
                <div class="pricingpage-faq__item">
                    <TxrExpandItem 
                    header={'Does Text Request require contracts?'} 
                    content={'Nope. You can start today and upgrade, downgrade, or cancel your plan at any time. If you do need a contract as part of your purchase protocol, <a class="txr-text__link" href="/contact" target="_blank">contact us</a>'}
                    />
                </div>
                <div class="pricingpage-faq__item">
                    <TxrExpandItem 
                    header={'Can I use my current business phone number texting?'} 
                    content={'Probably. We can text-enable all landline phone numbers, and most VOIP and toll-free numbers, without affecting voice services. <a class="txr-text__link" href="/landline-texting" target="_blank">Check your number here</a>, or <a class="txr-text__link" href="/contact" target="_blank">contact us</a> with questions.'}
                    />
                </div>
                <div class="pricingpage-faq__item">
                    <TxrExpandItem 
                    header={'How long does setup take?'} 
                    content={'Our goal is to have you set up, trained, and sending messages within 24 hours. Some external factors like your own schedule may affect this, but we\'re here to help you launch ASAP.'}
                    />
                </div>
                <div class="pricingpage-faq__item">
                    <TxrExpandItem 
                    header={'Can I send more texts than are included in my plan?'} 
                    content={'Yes. We won\'t stop you from texting. You will just pay your plan\'s per-text rate for additional texts. These overages will be added to your next billing.'}
                    />
                </div>         
                <div class="pricingpage-faq__item">
                    <TxrExpandItem 
                    header={'Is Text Request HIPAA compliant?'} 
                    content={'We have a HIPAA compliant account option, yes. It even comes with a Business Associate Agreement (BAA) upon request. These accounts are different from our standard accounts, and will need to be set up by a Text Request employee. <a class="txr-text__link" href="/contact" target="_blank">Contact us</a> today to set up your HIPAA compliant texting account.'}
                    />
                </div>          
                <div class="pricingpage-faq__item">
                    <TxrExpandItem 
                    header={'How long can a text be?'} 
                    content={'One text holds up to 160 characters. You can send and receive messages up to 1,600 characters, and they will appear as one message to both you and your contacts, but they will count as multiple texts towards your plan’s usage. Including a picture, PDF, or video will add one extra text per recipient to your plan’s usage. Using special characters like an emoji or em dash reduces your character limit. Why these limits? Mobile carriers have set these standards, and we are following their lead to keep things consistent and easier for everyone. We understand it gets pretty technical, and sometimes confusing. We’re happy to talk through details with you, just <a class="txr-text__link" href="/contact" target="_blank">contact us</a>. We also show a character counter everywhere you send a message in Text Request. You can always see how many characters are in your message, how many texts it is, and—when sending to multiple people—how many total texts will count towards your plan’s usage.'}
                    />
                </div>                                         
            </div>
        )
    }

    
}

export default TxrPricingFaqItems;